/* eslint-disable  @typescript-eslint/no-explicit-any */
import { TThunkAction } from '../../types/redux';
import {
  fetchGetSpecialistsCatalog,
  IGetSpecialistsCatalogResponse,
  IGetSpecialistsCatalogResponseError,
  IGetSpecialistsCatalogResponse200 as IRes200,
  IGetSpecialistsCatalogResponse400 as IRes400,
} from '../../repositories/demand/v1/get-specialists-catalog';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EActionTypes } from '../../constants/actionTypes/specialists';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { REALTORS_ON_PAGE } from '../../constants/pagination';
import { IGeoExV4Schema } from '../../repositories/demand/entities/geo/GeoExV4Schema';

export const requestAction = actionGenerator<EActionTypes.GET_SPECIALISTS_REQUEST>(
  EActionTypes.GET_SPECIALISTS_REQUEST,
);

export const successAction = actionGenerator<EActionTypes.GET_SPECIALISTS_SUCCESS, IGetSpecialistsCatalogResponse>(
  EActionTypes.GET_SPECIALISTS_SUCCESS,
);

export const failureAction = actionGenerator<EActionTypes.GET_SPECIALISTS_FAILURE, IGetSpecialistsCatalogResponseError>(
  EActionTypes.GET_SPECIALISTS_FAILURE,
);

export interface IGetSpecialistsParams {
  geo: IGeoExV4Schema;
  pageNumber?: number;
}

export const getSpecialists = (params: IGetSpecialistsParams): TThunkAction<Promise<void>> => {
  const { geo, pageNumber = 1 } = params;

  return (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    dispatch(requestAction());

    return fetchGetSpecialistsCatalog<IRes200, IRes400>({
      httpApi,
      parameters: {
        geo,
        limit: REALTORS_ON_PAGE,
        offset: (pageNumber - 1) * REALTORS_ON_PAGE,
      },
    })
      .then(res => {
        if (res.statusCode === 200) {
          dispatch(successAction(res.response));
        } else {
          dispatch(failureAction(res.response));
        }
      })
      .catch(e => {
        logger.error(e, {
          domain: 'getSpecialist.ts',
        });
        dispatch(failureAction(e.message));
      });
  };
};

export type TGetSpecialistActions =
  | ITypedReduxAction<EActionTypes.GET_SPECIALISTS_REQUEST, any>
  | ITypedReduxAction<EActionTypes.GET_SPECIALISTS_SUCCESS, any>
  | ITypedReduxAction<EActionTypes.GET_SPECIALISTS_FAILURE, any>;
